import { GetNationalityUseCase } from '../../../application';

export default class GetNationalityService {
    constructor() {}

    async execute(event) {
        const request = await GetNationalityUseCase(event);

        return request;
    }
}
